// window.addEventListener("load", (event) => {
//   var igEvents = window.igEvents || [];
//   igEvents.push({
//     "event": "Product Page Viewed"
//   })
//   var tagged_custm_var_id = $(".customer-banner-intelligems-jtpl").attr("value");
//     var sale_price = igData.price.getPriceByVariantId(tagged_custm_var_id);
//   var new_price = "$"+sale_price;
//   $(".price-item.price-item--sale").text(new_price);
//   console.log(igData);
//   console.log(campaigns_data);

// $(document).ready(function () {
//   function showDescription() {
//     $(this).find(".quick-view-button").stop(true, true).slideToggle();
//   }
//   showDescription();
//   $(".produt-grid-item-wrapper-jtpl,.grid__item.slider__slide")
//     .on("mouseenter", function () {
//       $(this).find(".quick-view-button").slideDown();
//     })
//     .on("mouseleave", function () {
//       $(this).find(".quick-view-button").slideUp();
//     });
// });
// });

$(window).on("load", function () {
  $(".product_image_desktop .carousel-nav").show();
  setTimeout(function () {
    $(".quick-navbar-wrapper").fadeIn();
    $(".pro-meta-logo-slider-main-wrapper .featured-logo-slider").css(
      "display",
      "block"
    );
    var productflkty = new Flickity(
      ".pro-meta-logo-slider-main-wrapper .featured-logo-slider .product-logo",
      {
        autoPlay: 3000,
        prevNextButtons: false,
        pageDots: false,
        lazyLoad: 1,
        adaptiveHeight: true,
        freeScroll: true,
        wrapAround: true,
        contain: true,
      }
    );

    // Reinitialize Flickity on window resize

    productflkty.resize();
  }, 1500);
});
$(document).ready(function () {
  const hosts = document.querySelectorAll('shopify-payment-terms');

// Check karo ki kam se kam ek element maujood hai
if (hosts.length > 0) {
  // Pehle element ka shadowRoot access karo
  const shadowRoot = hosts[0].shadowRoot;
  
  if (shadowRoot) {
    // Style tag create karo
    const style = document.createElement('style');
    style.textContent = `
      p#shopify-installments {
        font-size: 12px;
        font-family: var(--font-body-family);
        line-height: normal;
        font-weight: 400;
      }
    `;
    shadowRoot.appendChild(style);
  }
}
  // $(".custom-annoucementbar").removeClass("hidden");

  // function initializeFlickity() {
  //   // Initialize Flickity
  //   var flkty = new Flickity(".jtpl-announcement-content", {
  //     autoPlay: 3000,
  //     prevNextButtons: false,
  //     pageDots: false,
  //     lazyLoad: 1,
  //     adaptiveHeight: true,
  //     freeScroll: true,
  //     wrapAround: true,
  //     contain: true,
  //   });
  // }
  // initializeFlickity();
  // $(window).resize(function () {
  //   initializeFlickity();
  // });
  if ($("body").hasClass("page-test-new-try-air-c")) {
    $(".custom-button .btn-text").click(function (event) {
      // Show an alert when the button is clicked
      // alert('Button clicked!');

      // Optionally prevent the default action if needed (e.g., navigation)
      event.preventDefault();
      $("html, body").animate(
        {
          scrollTop: $(".featured-product-section").offset().top,
        },
        1000
      ); // 1000ms = 1 second for smooth scroll
    });
  }
  // $(".metafield-rich_text_field")
  //   .find("p strong")
  //   .eq(1)
  //   .addClass("insider-copy-text .red-txt");

  // $(".metafield-rich_text_field .insider-copy-text .red-txt").on("click", function () {
  //   var copyText = $(".insider-copy-text .red-txt").text();

  //   // Create a temporary input element to hold the text
  //   var $tempInput = $("<input>");
  //   $("body").append($tempInput);
  //   $tempInput.val(copyText).select(); // Set the value and select it
  //   document.execCommand("copy"); // Copy the selected text

  //   $tempInput.remove();
  //   $(this).addClass("active");
  //   setTimeout(() => {
  //     $(this).removeClass("active");
  //   }, 500);

  //   // Uncomment the following line if you want to alert the copied text
  //   console.log("Code copied: " + copyText);
  // });

$(".metafield-rich_text_field")
  .find("p strong")
  .eq(1) 
  .addClass("insider-copy-text");

$(".metafield-rich_text_field")
  .find("p strong")
  .eq(2) 
  .addClass("insider-copy-text red-txt")
  //.css("cursor", "pointer"); 


$(".metafield-rich_text_field .insider-copy-text.red-txt").on("click", function () {
  var copyText = $(this).text().trim();

  navigator.clipboard.writeText(copyText)
    .then(() => {
      $(this).addClass("active");
      console.log("Code copied: " + copyText);
      setTimeout(() => {
        $(this).removeClass("active");
      }, 500);
    })
    .catch(err => {
      console.error("Failed to copy text: ", err);
    });
});

  $(".image_cover") // Target the image cover specifically
    .on("mouseenter", function () {
      $(this).find(".category_button").fadeOut(); // Fade out the button when hovered
    })
    .on("mouseleave", function () {
      $(this).find(".category_button").fadeIn(); // Fade in the button when hover ends
    });
  if ($("body").hasClass("index")) {
    $(".image_cover_custom_jtpl.Supplements").on("click", function (event) {
      // Change the window location to the target URL
      // alert("helloredirect")
      event.preventDefault();
      window.location.href =
        "https://www.reathlete.com/collections/re-supplements";
    });
  }
  $('a[href^="#"]').on("click", function (event) {
    // alert("hai")
    // Prevent the default jump to the element
    event.preventDefault();

    // Get the target element
    var target = $(this.hash);

    // If the target exists, scroll to it smoothly
    if (target.length) {
      // Show alert before scrolling
      //alert("Scrolling to: " + target.attr('id'));

      // Perform smooth scrolling
      $("html, body").animate(
        {
          scrollTop: target.offset().top,
        },
        1500
      ); // 1000ms = 1 second scroll duration
    } else {
      // Show alert if target is not found
      // alert("Target not found!");
    }
  });
  var hashValue = window.location.hash.substring(1);

  //console.log(hashValue);
  if (hashValue) {
    var targetElement = $("." + hashValue);
    //console.log("targetElement",targetElement)
    if (targetElement.length) {
      $("html, body").animate(
        {
          scrollTop: targetElement.offset().top,
        },
        1000
      );
    }
  }
});

$(document).ready(function () {
  $(".product_image_desktop .carousel-nav").hide();
  $("#merchantwidgetiframe").attr("title", "merchant-widget");
});
$(document).ready(function () {
  function addclass() {
    var size = $(window).width(); // Move size inside the function
    if (size < 769) {
      $(".footer__blocks-faq-wrapper").attr("id", "faq");
      // $(".footer__blocks-faq-wrapper dd").attr("style", "display:none;");
    } else {
      $(".footer__blocks-faq-wrapper").removeAttr("id");
      // $(".footer__blocks-faq-wrapper dd").removeAttr("style");
    }
  }
  addclass(); // Call once on load
  $(window).resize(function () {
    addclass(); // Call on resize
  });
});

$(document).ready(function () {
  function isMobile() {
    return $(window).width() < 768; // Adjust the width as needed
  }

  if (!isMobile()) {
    $(".produt-grid-item-wrapper-jtpl, .grid__item.slider__slide")
      .on("mouseenter", function () {
        $(this).find(".quick-view-button").stop(true, true).slideDown();
      })
      .on("mouseleave", function () {
        $(this).find(".quick-view-button").stop(true, true).slideUp();
      });
  }
});

// $(document).ready(function () {
//   $(".produt-grid-item-wrapper-jtpl, .grid__item.slider__slide")
//     .on("mouseenter", function () {
//       $(this).find(".quick-view-button").stop(true, true).slideDown();
//     })
//     .on("mouseleave", function () {
//       $(this).find(".quick-view-button").stop(true, true).slideUp();
//     });
// });

$(document).ready(function () {
  // start js for accordian footer

  // endjs for accordian footer
  var htmlContent = $(".custom_badge_bar").html();
  $(".main_badge_content").append(htmlContent);
  $(".custom_badge_bar").hide();
});
$(document).ready(function () {
  var htmlContent = $(".custom_footer_badge").html();
  $(".custom_footer_sika_badge_jtpl").append(htmlContent);
  $(".custom_footer_badge").hide();
});

$(document).ready(function () {
  $("body.page-anti-aging iframe#launcher")
    .next()
    .addClass("chat-bubble-iframe--jtpl");
  $("body.page-anti-aging .button-custom-jtpl")
    .eq(0)
    .removeClass("movement-btn-jtpl");
  $("body.page-anti-aging .button-custom-jtpl")
    .eq(0)
    .find("a")
    .removeClass("non-skip");
  $("body.page-anti-aging .button-custom-jtpl")
    .eq(1)
    .removeClass("movement-btn-jtpl");
  $("body.page-anti-aging .skip-btn-jtpl")
    .parent(".button-custom-jtpl")
    .removeClass("movement-btn-jtpl");
  $(".jtpl-rich-text-btns a").click(function () {
    if (!$(this).hasClass("active")) {
      $(".jtpl-rich-text-btns a.active").removeClass("active");
      $(this).addClass("active");
    }
  });
  $("body.page-listiclehr .listiclehr-image-with-text-full .button-wrapper").on(
    "click",
    function (event) {
      event.preventDefault(); // Prevent the default action of the link

      // Check if a next section was found
      var VarCurr = $(".section--full-width").eq(2);
      // $(VarCurr).find(".custom-sticky-buttons_jtpl").hide();
      var crrntPopNew = $(VarCurr).attr("id");
      var buttonText = $("#" + crrntPopNew)
        .find(".button-wrapper a")
        .text()
        .trim();
      //console.log("button_text:", buttonText); // Output: "Reveal the Next Trap"

      var url = window.location.href;
      if (url.indexOf("listiclehr") > -1) {
        window.history.pushState(
          "",
          "" + crrntPopNew,
          "/pages/listiclehr#" + crrntPopNew
        );
        $(".sticky_buttons_wrapper_jtpl .movement-btn-jtpl .non-skip ").text(
          buttonText
        );
      } else {
        window.history.pushState(
          "",
          "" + crrntPopNew,
          "/pages/listiclehr#" + crrntPopNew
        );
      }

      // Animate the scroll to the next section
      $("html, body").animate(
        {
          scrollTop: $(".section--full-width").eq(2).offset().top,
        },
        500
      );

      //  Duration of the animation in milliseconds
    }
  );
  $("body.page-anti-aging a.find-out-more-btn").on("click", function (event) {
    event.preventDefault(); // Prevent the default action of the link

    // Check if a next section was found
    var VarCurr = $(".section--full-width").eq(1);
    $(VarCurr).find(".custom-sticky-buttons_jtpl").hide();
    var crrntPopNew = $(VarCurr).attr("id");

    var url = window.location.href;
    if (url.indexOf("listairb") > -1) {
      window.history.pushState(
        "",
        "" + crrntPopNew,
        "/pages/listairb#" + crrntPopNew
      );
    } else {
      window.history.pushState(
        "",
        "" + crrntPopNew,
        "/pages/listair#" + crrntPopNew
      );
    }

    // Animate the scroll to the next section
    $("html, body").animate(
      {
        scrollTop: $(".section--full-width").eq(1).offset().top + 10,
      },
      500
    ); // Duration of the animation in milliseconds
  });
  $("body.page-anti-aging  a.non-skip, body.page-listiclehr .non-skip").on(
    "click",
    function (event) {
      event.preventDefault(); // Prevent the default action of the link

      // Get the current scroll position
      var currentScrollTop = $(window).scrollTop();

      // Find the next .section--full-width element after the current scroll position
      var $nextSection = $(".section--full-width")
        .filter(function () {
          return $(this).offset().top > currentScrollTop;
        })
        .first();
      if (
        $("body").hasClass("page-listiclehr") == true &&
        $(window).width() < 767
      ) {
        // console.log($(".section--full-width:eq(0)"));
        var inview = $(".section--full-width:eq(0)").inView();
        // console.log(inview+"==="+$(window).scrollTop());
        if (inview == true || $(window).scrollTop() < 100) {
          var $nextSection = $(".section--full-width:eq(2)");
        }
      }

      var crrntPop = $($nextSection).attr("id");
      var buttonText = $("#" + crrntPop)
        .find(".button-wrapper a")
        .text()
        .trim();

      //console.log("button_text:", buttonText);
      //  console.log(crrntPop);
      // Check if a next section was found
      if ($nextSection.length) {
        // Animate the scroll to the next section
        $("html, body").animate(
          {
            scrollTop: $nextSection.offset().top + 10,
          },
          500
        ); // Duration of the animation in milliseconds

        var url = window.location.href;
        // if(url.indexOf("listairb") > -1){
        //    window.history.pushState("", "" + crrntPop, "/pages/listairb#" + crrntPop);

        // }
        if (url.indexOf("listiclehr") > -1) {
          window.history.pushState(
            "",
            "" + crrntPop,
            "/pages/listiclehr#" + crrntPop
          );
          if (buttonText) {
            $(
              ".sticky_buttons_wrapper_jtpl .movement-btn-jtpl .non-skip "
            ).text(buttonText);
          } else if (buttonText == "") {
            $(
              ".sticky_buttons_wrapper_jtpl .movement-btn-jtpl .non-skip "
            ).text("Keep Reading");
          }
        } else if (url.indexOf("listairb") > -1) {
          window.history.pushState(
            "",
            "" + crrntPop,
            "/pages/listairb#" + crrntPop
          );
        } else {
          window.history.pushState(
            "",
            "" + crrntPop,
            "/pages/listair#" + crrntPop
          );
        }

        $(this)
          .parents(".section--full-width")
          .find(".custom-sticky-buttons_jtpl")
          .hide();
      } else {
        // console.log("No next section found to scroll to.");
      }
    }
  );

  $("body.page-listiclehr .button-wrapper  a.hideMobile").on(
    "click",
    function (event) {
      event.preventDefault(); // Prevent the default action of the link
      // Get the current scroll position
      var currentScrollTop = $(window).scrollTop();
      var current_section = $(this)
        .parents(".section--full-width")
        .index(".section--full-width");
      var next_index = current_section + 1;
      var $nextSection = $(
        ".section--full-width:eq(" +
          next_index +
          "), .jtpl-rich-text:eq(" +
          next_index +
          ")"
      );
      // var $nextSection = $(".section--full-width, .jtpl-rich-text")
      //  .filter(function () {
      //    return $(this).offset().top > currentScrollTop;
      //  })
      //  .first();

      //console.log($nextSection);
      var crrntPop = $($nextSection).attr("id");
      //  console.log(crrntPop);
      // Check if a next section was found
      if ($nextSection.length) {
        // Animate the scroll to the next section
        $("html, body").animate(
          {
            scrollTop: $nextSection.offset().top + 10,
          },
          500
        ); // Duration of the animation in milliseconds

        var url = window.location.href;
        if (url.indexOf("listairb") > -1) {
          window.history.pushState(
            "",
            "" + crrntPop,
            "/pages/listairb#" + crrntPop
          );
        } else if (url.indexOf("listair") > -1) {
          window.history.pushState(
            "",
            "" + crrntPop,
            "/pages/listair#" + crrntPop
          );
        } else if (url.indexOf("listiclehr") > -1) {
          //  console.log("crrntPop"+crrntPop)
          // console.log("button_text",button_text)
          window.history.pushState(
            "",
            "" + crrntPop,
            "/pages/listiclehr#" + crrntPop
          );
          if (buttonText) {
            $(
              ".sticky_buttons_wrapper_jtpl .movement-btn-jtpl .non-skip "
            ).text(buttonText);
          } else if (buttonText == "") {
            $(
              ".sticky_buttons_wrapper_jtpl .movement-btn-jtpl .non-skip "
            ).text("Keep Reading");
          }
        } else {
          window.history.pushState(
            "",
            "" + crrntPop,
            "/pages/listair#" + crrntPop
          );
        }

        $(this)
          .parents(".section--full-width")
          .find(".custom-sticky-buttons_jtpl")
          .hide();
      } else {
        // console.log("No next section found to scroll to.");
      }
    }
  );

  $("body.page-anti-aging a.skip-btn-jtpl").on("click", function (event) {
    event.preventDefault(); // Prevent the default action of the link

    // Get the current scroll position
    var currentScrollTop = $(window).scrollTop();

    // Find the next .section--full-width element after the current scroll position
    var $nextSection = $(".jtpl-rich-text:first")
      .filter(function () {
        return $(this).offset().top > currentScrollTop;
      })
      .first();
    var crrntskipPop = $($nextSection).attr("id");
    //   console.log(crrntskipPop);
    // Check if a next section was found
    if ($nextSection.length) {
      // Animate the scroll to the next section
      $("html, body").animate(
        {
          scrollTop: $nextSection.offset().top,
        },
        1000
      ); // Duration of the animation in milliseconds

      var url = window.location.href;
      if (url.indexOf("listairb") > -1) {
        window.history.pushState(
          "",
          "" + crrntskipPop,
          "/pages/listairb#" + crrntskipPop
        );
      } else if (url.indexOf("listiclehr") > -1) {
        window.history.pushState(
          "",
          "" + crrntskipPop,
          "/pages/listiclehr#" + crrntskipPop
        );
      } else {
        window.history.pushState(
          "",
          "" + crrntskipPop,
          "/pages/listair#" + crrntskipPop
        );
      }
    } else {
      //  console.log("No next section found to scroll to.");
    }
  });

  if ($(".add-review-section-jtpl").length > 0) {
    $(".add-review-section-jtpl:first").remove();
  }

  $(".custom-annoucementbar").removeClass("hidden");

  $(document).on("click", ".mp4-cntnt-video-jtpl", function () {
    var video_length = $(this).parents(
      ".joincommunityvideocontent__image-wrapper"
    ).length;
    //console.log("custom-length" + video_length);
    if (video_length < 1) {
      var chkwndowdt = $(window).width();
      if (chkwndowdt < 640) {
        $(this).attr("style", "padding-bottom: 56.25%!important;");
      }
    }
  });
  setInterval(function () {
    $(".btn-next-tab").trigger("click");
  }, 5000);

  $(document).on("click", ".btn-next-tab", function (e) {
    e.preventDefault();
    e.stopPropagation();
    var wrapper = $(this).closest(".featured_tabs__wrapper");
    if ($(wrapper).find(".tab_links .active").next("li").length > 0) {
      $(wrapper).find(".tab_links .active").next("li").trigger("click");
    } else {
      $(wrapper).find(".tab_links li:first").trigger("click");
    }
  });
  $(document).on("click", ".btn-prv-tab", function (e) {
    e.preventDefault();
    e.stopPropagation();
    var wrapper = $(this).closest(".featured_tabs__wrapper");
    $(wrapper).find(".tab_links .active").prev("li").trigger("click");
  });
  $(".sticky-btn").click(function () {
    $(".product-form__submit.btn_atc").trigger("click");
  });

  $(".btn-sticky-jtpl").click(function () {
    $(".product-form .product-form__submit").trigger("click");
  });

  if (window.location.href.indexOf("/products") > -1) {
    // sticky cta bar
    $.fn.inView = function () {
      var win = $(window);
      var obj = $(this);

      if (obj.length === 0) {
        //  console.error("Element not found");
        return false;
      }

      var scrollPosition = win.scrollTop();
      var visibleArea = win.scrollTop() + win.height();
      var objEndPos = obj.offset().top + obj.outerHeight();

      return visibleArea >= objEndPos && scrollPosition <= objEndPos;
    };
  }
  // JS for sticky "page-listclehos"
  setTimeout(() => {
    $("body").removeClass("loading");
  }, 300);
  
    const target = document.querySelector('.main-hostag-img-text-jtpl');
    if (target) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {

      if (!entry.isIntersecting) {
        // Element is OUT of view
        document.body.classList.add('page-listclehos');
      } else {
        // Element is IN view
        document.body.classList.remove('page-listclehos');
      }
    });
  }, {
    root: null,      
    threshold: 0.9     
  });
  
  observer.observe(target);
  }

  $(window).scroll(function () {
    if (window.location.href.indexOf("/products") > -1) {
      var inview = $(".button-warpper-grid").inView();
      if (inview == true) {
        $(".main-sticky-bar").removeClass("is-fixed");
        $("body").removeClass("main-body-sticky");
      } else {
        var scroll = $(window).scrollTop();
        if (scroll > 200) {
          $(".main-sticky-bar").addClass("is-fixed");
          $("body").addClass("main-body-sticky");
        } else {
          $(".main-sticky-bar").removeClass("is-fixed");
          $("body").removeClass("main-body-sticky");
        }
      }
    }
    // scroll down all cta's button on purchase section
    if($("body").hasClass("page-listclehos")){
       var scroll = $(window).scrollTop();
       var inviewRechText = $(".jtpl-rich-text").inView();
         if (inviewRechText == true && scroll > 200) {
          $("body").addClass("scroll-richtext-jtpl");
        }else{
           $("body").removeClass("scroll-richtext-jtpl");
        }
    }

    if ($("body").hasClass("custom-new-pages")) {
      var scroll = $(window).scrollTop();
      //console.log("scrooll"+scroll)
      if (scroll > 100) {
        $(".main-sticky-bar").addClass("is-fixed");
        $("body").addClass("main-body-sticky");
      } else {
        $(".main-sticky-bar").removeClass("is-fixed");
        $("body").removeClass("main-body-sticky");
      }
    }
  });

  $(document).on("click", ".banner__media.media.hideDesktop", function () {
    var url = $(this)
      .parent()
      .find(".banner__box .banner__buttons a")
      .attr("href");
    window.location.href = url;
  });

  $(".product-main-media").flickity({
    wrapAround: false,
    pageDots: true,
    adaptiveHeight: true,
    contain: true,
    imagesLoaded: true,
    resize: true,
  });

  // Conditionally hide page dots based on slide count

  $(".thumbnails.carousel-desktop.carousel-nav").flickity({
    asNavFor: ".product-main-media",
    pageDots: true,
    draggable: true,
    contain: true,
    percentPosition: false,
    groupCells: true,
    groupCells: 4,
    verticalCells: true,
  });

  try {
    var flkty = new Flickity(
      ".product-featured-banner-bottom, .product-featured-banner .home-banner-wrapper, .carousel "
    );
    var carouselStatus = document.querySelector(".carousel-status");

    function updateStatus() {
      var slideNumber = flkty.selectedIndex + 1;
      //       carouselStatus.textContent = slideNumber + '/' + flkty.slides.length;
    }
    updateStatus();
    flkty.on("select", updateStatus);
  } catch (err) {
    // console.log(err);
  }

  $(".toggle").click(function (e) {
    e.preventDefault();

    let $this = $(this);

    if ($this.next().hasClass("show")) {
      $this.next().removeClass("show");
      $this.next().slideUp(350);
    } else {
      $this.parent().parent().find("li .inner").removeClass("show");
      $this.parent().parent().find("li .inner").slideUp(350);
      $this.next().toggleClass("show");
      $this.next().slideToggle(350);
    }
  });

  // Smooth Scrolling Start

  // Add smooth scrolling to all links
  $(".section-links a").on("click", function (event) {
    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash
      var hash = this.hash;

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $("html, body").animate(
        {
          scrollTop: $(hash).offset().top,
        },
        800,
        function () {}
      );
    } // End if
  });

  // Add smooth scrolling to all links
  $(".custom-buttons-wrapper a").on("click", function (event) {
    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash
      var hash = this.hash;

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $("html, body").animate(
        {
          scrollTop: $(hash).offset().top,
        },
        800,
        function () {}
      );
    } // End if
  });

  // Smooth Scrolling end

  // Accordian with Images

  // $("#services__accordion .accordion  h3").click(function (e) {
  // 		e.stopPropagation();
  //     // The panel is not the H3, but its parent.
  //     let panel = $(this).parent(),
  //             tabName = panel.attr("tab-name"),
  //             image = $("#" + tabName + "-img");

  //     // Slide Up all other panels
  //     panels.slideUp();
  //     images.hide();

  //     // Slide Down target panel, and target image.
  //     panel.find(".accordion__body").slideDown();
  //     image.fadeIn('slow');

  //     $(".accordion  h3.active").removeClass('active');
  //     $(this).addClass('active');

  //     return false;
  // }).eq(0).trigger('click');

  // Accordian end

  //   let panels = $("#services__accordion > .accordion > .accordion__body").hide()

  // // Hide all accordion images
  // images = $("#accordion__img > img").hide();

  // // On click of a panel title

  // $("#services__accordion .accordion  h3").click(function (e) {
  // 		e.stopPropagation();
  //     // The panel is not the H3, but its parent.
  //     let panel = $(this).parent(),
  //             tabName = panel.attr("tab-name"),
  //             image = $("#" + tabName + "-img");

  //     // Slide Up all other panels
  //     panels.slideUp();
  //     images.hide();

  //     // Slide Down target panel, and target image.
  //     panel.find(".accordion__body").slideDown();
  //     image.fadeIn('slow');

  //     $(".accordion  h3.active").removeClass('active');
  //     $(this).addClass('active');

  //     return false;
  // }).eq(0).trigger('click');

  $(function () {
    // $(".accordion-content:not(:first-of-type)").css("display", "none");
    // $(".js-accordion-title:first-of-type").addClass("open");

    $(".js-accordion-title").click(function () {
      $(".open").not(this).removeClass("open").next().slideUp(300);
      $(this).toggleClass("open").next().slideToggle(300);
    });
  });

  $(".expand-icon").click(function (e) {
    $(this).addClass("expanded");
    $(".expand-icon").removeClass("expanded");
  });

  $("#accordion-container-jtpl .accordion  h3").click(function () {
    var tab_id = $(this).parents(".accordion").attr("tab-name");
    $(".accordian-img").first().removeClass("current");
    $(".accordion").removeClass("current");
    $(".accordian-img").removeClass("current");
    $(this).parents(".accordion").addClass("current");
    $("#" + tab_id).addClass("current");
  });

  $(".accordian-img").first().addClass("current");
  $(".accordian-inner-wrapper .accordion").first().addClass("current");
  $("#accordion-container .accordion  h3").click(function () {
    var tab_id = $(this).parents(".accordion").attr("tab-name");
    $(".accordian-img").first().removeClass("current");
    $(".accordion").removeClass("current");
    $(".accordian-img").removeClass("current");

    $(this).parents(".accordion").addClass("current");
    $("#" + tab_id).addClass("current");
  });

  $(document).on("click", ".video-play-icon-mob", function () {
    $(this).closest(".shopify-section").find(".video-section__poster").click();
  });
  $(document).on("click", ".tab_link", function (e) {
    e.preventDefault();
    e.stopPropagation();
    var $el = $(this),
      $el_wrap = $el.closest(".featured_tabs__wrapper"),
      target = $el.data("target");
    $el_wrap.find(".featured_tabs__content").hide();
    $el_wrap.find(".tab_link").removeClass("active");
    $el.addClass("active");
    $(target).show();
  });

  $(".featured_tabs__wrapper").each(function () {
    $(this)
      .find(".featured_tabs__content")
      .first()
      .find(".tab_link")
      .first()
      .trigger("click");
  });

  $(document).on("click", "#myBtn", function () {
    var $this = $(this);
    if ($this.text() == "see more") {
      $this.text("see less").addClass("active");
      $this.prev().slideDown();
    } else {
      $this.text("see more").removeClass("active");
      $this.prev().slideUp();
    }
  });

  $(document).on("click", ".video-section__poster", function () {
    var $el = $(this),
      $el_wrap = $el.closest(".video-section__media"),
      iframe = $el_wrap.find("iframe");
    if ($el_wrap.find("iframe").length > 0) {
      var src = $(iframe).get(0).src;

      if (src.indexOf("?") != -1) {
        $(iframe).get(0).src += "&autoplay=1";
      } else {
        $(iframe).get(0).src += "?autoplay=1";
      }
    }
  });

  $(document).on("click", ".trigger_modal", function () {
    var $el = $(this),
      target = $el.data("target");
    $(target).addClass("show-modal");
  });

  $(document).on("click", ".close-button", function () {
    $(".modal").removeClass("show-modal");
  });

  $(window).on("click", function (event) {
    var classes = event.target.classList.value;
    if (classes.indexOf("modal") != -1) {
      $(".modal").removeClass("show-modal");
    }
  });

  $(document).on("click", ".show_more_video", function (e) {
    e.preventDefault();
    var $el = $(this),
      target = $el
        .closest(".main-user-experience")
        .find(".js--video_list__item");
    $(target).removeClass("hidden").show();
  });

  $(document).on("click", "[data-add-to-cart]", function (e) {
    e.preventDefault();

    let $form = $(this).closest("form");

    let formData = {
      items: [
        {
          id: parseInt($form.find('[name="id"]').val()),
          quantity: 1,
        },
      ],
    };

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        window.location.href = "/checkout";
      })
      .catch((error) => {
        // console.error("Error:", error);
      });
  });
  // Compare Page
  // Compare Page
  $("button.compare_label").click(function (e) {
    $(".cover").fadeIn("300");
  });

  $(".compare_now").click(function (e) {
    e.preventDefault();

    $(".cover").fadeIn("300");
    var query_url = "";
    if ($(".compare_product_image:checked").length < 2) {
      alert("Please select the products");
    } else {
      $(".compare_product_image").each(function (index, value) {
        if ($(this).is(":checked")) {
          if (query_url == "") {
            query_url = $(this).val();
          } else {
            query_url = query_url + "&" + $(this).val();
          }
        }
      });
      window.location.href = "/pages/compare-page?" + query_url;
    }
  });
  $(".close").click(function () {
    $(".cover").fadeOut("300");
  });
  if (window.location.href.indexOf("?") > -1) {
    var query_string = window.location.href.split("?")[1];
    var queries = [];
    $.each(query_string.split("&"), function (c, q) {
      queries[c] = q;
    });

    $.each(queries, function (c, q) {
      //         $('.product_compare_show[data-value="'+q+'"]').css('display','block');
      //               $('.scrool_table td[data-value="'+q+'"]').css('display','block');
    });
  }
  var new_count = $(".compare_product_image:checked").length;
  $(".compare_now").text("Compare " + new_count + " Products");

  $(document).on("click", ".compare_product_image", function () {
    var new_count = $(".compare_product_image:checked").length;
    $(".compare_now").text("Compare " + new_count + " Products");
  });
  var new_count = $(".compare_product_image:checked").length;
  $(".compare_now").text("Compare " + new_count + " Products");

  // compare page js
  function getwidth() {
    var get_length = $(".scrool_table table").find("tr:first td").length;

    if (get_length > 4) {
      $(".compare_page_result_inner").addClass("hand-icon-remove");
    } else {
      $(".compare_page_result_inner").removeClass("hand-icon-remove");
    }
    var set_width = 100;

    var newWindowWidth = $(window).width();
    if (newWindowWidth > 768) {
      for (i = 0; i <= get_length - 5; i++) {
        set_width = set_width += 20;
        var set_width2 = set_width * 2;
        var set_width22 = set_width2 + "%";
        var actual_width = set_width + "%";
        //     alert(actual_width);
        $(".scrool_table table").css("width", actual_width);

        function checkScreenSize() {
          var newWindowWidth = $(window).width();
          if (newWindowWidth < 769) {
            $(".compare_page_result_inner").css("width", set_width22);
          } else {
            $(".compare_page_result_inner").css("width", "auto");
          }
        }
        checkScreenSize();

        $(window).on("resize", function (e) {
          checkScreenSize();
        });
      }
    } else {
      $(".compare_page_result_inner").addClass("hand-icon-remove");

      for (i = 0; i < get_length - 1; i++) {
        set_width = set_width += 10;
        var set_width2 = set_width * 2;
        var set_width22 = set_width2 + "%";
        var actual_width = set_width + "%";
        //     alert(actual_width);
        $(".scrool_table table").css("width", actual_width);
        function checkScreenSize() {
          var newWindowWidth = $(window).width();
          if (newWindowWidth < 769) {
            $(".compare_page_result_inner").css("width", set_width22);
          } else {
            $(".compare_page_result_inner").css("width", "auto");
          }
        }
        checkScreenSize();

        $(window).on("resize", function (e) {
          checkScreenSize();
        });
      }
    }
  }
  getwidth();

  const slider = document.querySelector(".scrool_table");
  let isDown = false;
  let startX;
  let scrollLeft;

  // slider.addEventListener('mousedown', (e) => {
  //   isDown = true;
  //   slider.classList.add('active');
  //   startX = e.pageX - slider.offsetLeft;
  //   scrollLeft = slider.scrollLeft;
  // });
  // slider.addEventListener('mouseleave', () => {
  //   isDown = false;
  //   slider.classList.remove('active');
  // });
  // slider.addEventListener('mouseup', () => {
  //   isDown = false;
  //   slider.classList.remove('active');
  // });
  // slider.addEventListener('mousemove', (e) => {
  //   if(!isDown) return;
  //   e.preventDefault();
  //   const x = e.pageX - slider.offsetLeft;
  //   const walk = (x - startX) * 3; //scroll-fast
  //   slider.scrollLeft = scrollLeft - walk;
  // });

  // PDP New Bundle About Us Faq
  $(document).on("click", ".about_description.mobile", function () {
    $(".about_description.mobile").toggleClass("active");
    // $(this).addClass('active');
    $(this).find(".content-outer-about-us").slideToggle();
  });

  // PDP Whats Included Slider
  if ($(".whats-included-content-wrap").length > 0) {
    $(".whats-included-content-wrap").slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow:
        '<div class="prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M14.71 6.71c-.39-.39-1.02-.39-1.41 0L8.71 11.3c-.39.39-.39 1.02 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L10.83 12l3.88-3.88c.39-.39.38-1.03 0-1.41z"></path></svg></div>',
      nextArrow:
        '<div class="next-arrow"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M9.29 6.71c-.39.39-.39 1.02 0 1.41L13.17 12l-3.88 3.88c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l4.59-4.59c.39-.39.39-1.02 0-1.41L10.7 6.7c-.38-.38-1.02-.38-1.41.01z"></path></svg></div>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            dots: true,
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }
  //PDP Tabs New Bundle
  $(document).on("click", ".new-bundels-tab-pdp.desktop .tab", function () {
    $(".new-bundels-tab-pdp.desktop .tab").removeClass("active");
    $(this).addClass("active");
    var dataIndex = $(this).attr("data-id");
    $(".new-bundels-tab-pdp.desktop .div-content").removeClass("active");
    $(".new-bundels-tab-pdp.desktop .div-content").hide();
    $(
      `.new-bundels-tab-pdp.desktop .div-content[data-id="${dataIndex}"]`
    ).addClass("active");
    $(
      `.new-bundels-tab-pdp.desktop .div-content[data-id="${dataIndex}"]`
    ).show();
  });

  $(".new-bundels-tab-pdp.desktop .tab").removeClass("active");
  $(".new-bundels-tab-pdp.desktop .tab:first").addClass("active");
  var dataIndex = $(".new-bundels-tab-pdp.desktop .tab:first").attr("data-id");
  $(".new-bundels-tab-pdp.desktop .div-content").removeClass("active");
  $(".new-bundels-tab-pdp.desktop .div-content").hide();
  $(
    `.new-bundels-tab-pdp.desktop .div-content[data-id="${dataIndex}"]`
  ).addClass("active");
  $(`.new-bundels-tab-pdp.desktop .div-content[data-id="${dataIndex}"]`).show();

  // PDP FAQ New Bundle
  $(document).on(
    "click",
    ".new-bundels-tab-pdp.mobile .elem-accordion",
    function () {
      $(this).toggleClass("active");
      $(this).find(".content-outer").slideToggle();
    }
  );
}); // ready
window.onload = function () {
  $(".compare_page_result_inner").addClass("active");
};

//table scrol hand js
$("body").on("pointerdown", function (e) {
  if (
    $(e.target)
      .parents(".compare_page_result_inner")
      .hasClass("hand-icon-remove")
  ) {
    $(e.target)
      .parents(".compare_page_result_inner")
      .removeClass("hand-icon-remove");
  }
});

$(document).ready(function () {
  $(".carousel-cell").addClass("pageloaded");
});

$("body").on("click", ".review_wrap", function (t) {
  t.preventDefault(),
    $("html, body").animate(
      { scrollTop: $(".customer-reviews").offset().top - 100 },
      500
    );
});

$(document).on(
  "click",
  ".rebuy-cart__flyout-actions .rebuy-cart__checkout-button",
  function () {
    var page_url = window.location.href;
    setCookie("page_url", page_url);
  }
);
function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
if (
  window.location.href.indexOf("/products/upheat-weighted-pad-vip-club") > -1
) {
  window.location.replace(
    "https://www.reathlete.com/products/upheat-weighted-pads"
  );
} else if (
  window.location.href.indexOf(
    "/products/copy-of-necka-neck-massager-one-time-offer"
  ) > -1
) {
  window.location.replace(
    "https://www.reathlete.com/products/necka-neck-massager"
  );
} else if (
  window.location.href.indexOf(
    "/products/reathlete-deep4s-massage-gun-vip-club"
  ) > -1
) {
  window.location.replace(
    "https://www.reathlete.com/products/reathlete-deep4s-massage-gun"
  );
}

var lastDiv = $("div#whats-include:first");
lastDiv.removeAttr("id");

$.fn.inView = function () {
  var win = $(window);
  var obj = $(this);

  // Check if obj exists
  if (obj.length === 0) {
    //console.error("Element not found");
    return false; // or handle appropriately
  }

  var scrollPosition = win.scrollTop();
  var visibleArea = scrollPosition + win.height();
  var objTop = obj.offset().top;
  var objHeight = obj.outerHeight();

  // Debugging output
  // alert(objTop + " .. " + objHeight);

  var objEndPos = objTop + objHeight;

  return visibleArea >= objEndPos && scrollPosition <= objEndPos;
};

$(window).scroll(function () {
  if ($(window).width() < 767) {
    // Adjust layout for mobile view
    // $("body.page-anti-aging .custom-multicolumn-jtpl")
    //   .eq(1)
    //   .removeClass("section--full-width");
    // $("body.page-anti-aging .slider-mobile-gutter .multicolumn-list__item")
    //   .eq(1)
    //   .addClass("section--full-width");

    // console.log("lessthan");

    // Check if specific elements are in view
    var inview = $(
      "#shopify-section-template--16266074882134__image_with_text_VpmnHL, header"
    ).inView();

    if (inview) {
      // console.log(inview);
      $(".find-out-more-btn").show();
      $(".non-skip").hide();
    } else {
      //  console.log(inview);
      $(".find-out-more-btn").hide();
      $(".non-skip").show();
    }

    var inviewRichText = $(".jtpl-rich-text").inView();
    var inviewFooter = $("footer").inView();
    // console.log("footer==" + inviewFooter);

    // Check if the rich text section is in view
    if (inviewRichText) {
      $(".sticky_buttons_wrapper_jtpl").hide();
    } else {
      $(".sticky_buttons_wrapper_jtpl").show();
    }

    // Get the scroll position
    var scrollTop = $(window).scrollTop();

    // Check if the rich text section exists before trying to get its offset
    if ($(".jtpl-rich-text").length) {
      var elementOffset = $(".jtpl-rich-text").offset().top;

      // Check if scroll position is greater than the element's offset
      if (scrollTop > elementOffset) {
        $(".sticky_buttons_wrapper_jtpl").hide();
        //  console.log("Scroll position is greater than .jtpl-rich-text section");
      }
    } else {
      //console.warn(".jtpl-rich-text not found");
    }

    // Check if at the bottom of the page
    if ($(window).scrollTop() + $(window).height() >= $(document).height()) {
      $(".sticky_buttons_wrapper_jtpl").hide();
      // console.log("End of page reached");
    }
  }
});

$(window).resize(function () {
  $(window).scroll(function () {
    if ($(window).width() < 767) {
      //console.log("lessthan");
      if ($("body").hasClass("page-listiclehr")) {
        $("body.page-listiclehr .button-wrapper  a.hideMobile").hide();
        var inview = $(
          "#shopify-section-template--17378365964374__image_with_text_dhi8je, header"
        ).inView();
        if (inview == true) {
          //  console.log(inview);
          $(".skip-btn-jtpl").show();
          $(".non-skip").hide();
        } else {
          // console.log(inview);
          $(".skip-btn-jtpl").hide();
          $(".non-skip").show();
        }
      } else {
        var inview = $(
          "#shopify-section-template--16266074882134__image_with_text_VpmnHL , header"
        ).inView();
        if (inview == true) {
          //  console.log(inview);
          $(".find-out-more-btn").show();
          $(".non-skip").hide();
        } else {
          // console.log(inview);
          $(".find-out-more-btn").hide();
          $(".non-skip").show();
        }
      }

      var inview = $(".jtpl-rich-text").inView();
      var inviewFooter = $("footer").inView();
      //  console.log("footer==" + inviewFooter);
      if ($("body").hasClass("page-listiclehr")) {
        $(".sticky_buttons_wrapper_jtpl").show();
      } else {
        if (inview == true) {
          $(".sticky_buttons_wrapper_jtpl").hide();
        } else {
          $(".sticky_buttons_wrapper_jtpl").show();
        }
        var scrollTop = $(window).scrollTop();
        var $richTextElement = $(".jtpl-rich-text");
        if ($richTextElement.length) {
          var elementOffset = $richTextElement.offset().top;
          if (scrollTop > elementOffset) {
            $(".sticky_buttons_wrapper_jtpl").hide();
            // console.log("Scroll position is greater than .jtpl-rich-text section");
          }

          if (
            $(window).scrollTop() + $(window).height() >=
            $(document).height()
          ) {
            $(".sticky_buttons_wrapper_jtpl").hide();
            // console.log("End of page reached");
          }
        }
      }
      if ($("body").hasClass("page-listiclehr")) {
        $(".sticky_buttons_wrapper_jtpl").show();
      }
    } //767
  });
});

$(document).ready(function () {
  $(
    ".listclehosb-logo-with-text-jtpl .rich-text__blocks a.button.button--primary"
  ).click(function () {
    $("html, body").animate(
      {
        scrollTop: $(".custom-listclehos").offset().top,
      },
      1000
    );
  });
  // $(
  //   ".main-hostag-img-text-jtpl .rich-text__blocks a.button.button--primary"
  // ).click(function () {
  //   $("html, body").animate(
  //     {
  //       scrollTop: $(
  //         ".custom-listclehos,body.page-activeairc .custom-activeairc"
  //       ).offset().top,
  //     },
  //     1000
  //   );
  // });
  $(".main-hostag-img-text-jtpl .rich-text__blocks a.button.button--primary").click(function () {
    console.log(`<<<<<<<<<<<<<<<<<clicked5625454>>>>>>>>>>>>>>>>>>>>>>>`);
    $("html, body").animate(
      {
        scrollTop: $(
          ".product-pricing-table-sec,body.page-activeairc .custom-activeairc"
        ).offset().top,
      },
      1000
    );
  });
  // featured section
   $(".featured-product a .button.button--secondary").click(function () {
    console.log(`<<<<<<<<<<<<<<<<<clicked5625454>>>>>>>>>>>>>>>>>>>>>>>`);
    $("html, body").animate(
      {
        scrollTop: $(
          ".product-pricing-table-sec,body.page-activeairc .custom-activeairc"
        ).offset().top,
      },
      1000
    );
  });
  // end js
 $(".page-listclehos .custom-featured-jtpl-btn a.product-form__submit").click(function () {
  console.log(`<<<<<<<<<<<<<<<<<clicked5625454>>>>>>>>>>>>>>>>>>>>>>>`);
    $("html, body").animate(
      {
        scrollTop: $(
          ".product-pricing-table-sec"
        ).offset().top,
      },
      1000
    );
  });
 $("body.page-activeairc .text-content-jtpl .custom-button,.custom-active-air .rich-text__blocks a.button.button--primary").click(function (event) {
    event.preventDefault();
    $("html, body").animate(
      {
        scrollTop: $("body.page-activeairc .custom-activeairc").offset().top,
      },
      1250
    );
  });
  $(
    ".page-try-air-c-bundle .sticky-atc .sticky-btn,.page-try-air-c-bundle .shoplift--button--primary"
  ).click(function () {
    event.preventDefault();
    $("html, body").animate(
      {
        scrollTop: $(".featured-product-section").offset().top,
      },
      1000
    );
  });
   $(".page-test-for-new .air-c-banner .page-width .custom-button " ).click(function () {
    event.preventDefault();
      $("html, body").animate({
        scrollTop: $(".featured-product").offset().top,
      }, 1000);
  });
});

var i_cnt = 0;
var topSectionReached = false;

$(window).scroll(function () {
  if ($(window).width() <= 767) {
    var urlqww = window.location.href;
    // console.log("location=", urlqww);

    // Get the first visible section
    var $visibleSection = null;
    $(".section--full-width").each(function () {
      var $section = $(this);
      var sectionTop = $section.offset().top;
      var sectionBottom = sectionTop + $section.outerHeight();
      var scrollPosition = $(window).scrollTop();

      if (
        sectionBottom > scrollPosition &&
        sectionTop < scrollPosition + window.innerHeight
      ) {
        $visibleSection = $section;
        return false; // Exit loop after first visible section
      }
    });

    // Check if we're at the top of the page (first section visible)
    var firstSection = $(".section--full-width").first();
    if (firstSection.length) {
      var firstSectionTop = firstSection.offset().top;
      var scrollPosition = $(window).scrollTop();
      topSectionReached = scrollPosition <= firstSectionTop + 10; // Adding small buffer
    }

    // Handle button text based on page and scroll position
    if (
      ($("body").hasClass("page-listair") ||
        $("body").hasClass("page-listairb")) &&
      topSectionReached
    ) {
      $(".sticky_buttons_wrapper_jtpl .button-wrapper .non-skip").text(
        "Find out more"
      );
      i_cnt = 0; // Reset counter when at top
    } else if (
      ($("body").hasClass("page-listair") ||
        $("body").hasClass("page-listairb")) &&
      i_cnt > 1
    ) {
      $(".sticky_buttons_wrapper_jtpl .button-wrapper .non-skip").text(
        "Continue"
      );
    } else {
      // Get button text from visible section
      if ($visibleSection) {
        var buttonText = $visibleSection
          .find(".button-wrapper a:first")
          .text()
          .trim();
        //  console.log("Current button text:", buttonText);
        if (buttonText) {
          $(".sticky_buttons_wrapper_jtpl .movement-btn-jtpl .non-skip").text(
            buttonText
          );
        }
        i_cnt++;
      } else {
        $(".sticky_buttons_wrapper_jtpl").hide();
      }

      if ($visibleSection) {
        var buttonText = $visibleSection
          .find(".button-wrapper a:first")
          .text()
          .trim();
        // console.log("Current button text:", buttonText);
        if (buttonText) {
          $(".sticky_buttons_wrapper_jtpl .button-wrapper .non-skip").text(
            buttonText
          );
        }
      }
    }

    // Check element visibility
    var shouldHideButton =
      isInViewport($(".banner-content")) ||
      isInViewport($(".footer")) ||
      isInViewport($(".support-section")) ||
      isInViewport($(".footer__blocks-wrapper")) ||
      isInViewport($(".footer-block-image"));

    // Toggle button visibility
    $(".button_wrapper_mobile").toggle(!shouldHideButton);
  }
});

// Helper function to check if element is in viewport
function isInViewport(element) {
  if (!element.length) return false;
  var rect = element[0].getBoundingClientRect();
  return rect.top <= window.innerHeight && rect.bottom >= 0;
}

if ($(window).width() <= 767) {
  if ($("body").hasClass("page-listiclehr")) {
    setTimeout(function () {
      var scrollAmount = $(document).height() * 0.0001;
      $("html, body").scrollTop(scrollAmount);
    }, 150);
  }
}
